import { getRequest } from '../../../services/api';
import type { Territory } from '../types';

import { makeGeoDataApi } from './makeGeoDataApi';

export async function fetchTerritories(filters?: {
  countryCode?: string;
  includeCountryFallbacks?: false;
}): Promise<Territory[]>;
export async function fetchTerritories(filters: {
  countryCode?: string;
  includeCountryFallbacks: true;
}): Promise<Territory<true>[]>;
export async function fetchTerritories(filters?: { countryCode?: string; includeCountryFallbacks?: boolean }) {
  const res = await getRequest('geography/territories', filters);

  return res.data.data;
}

export const territoriesApi = makeGeoDataApi<Territory<true>, [string]>(
  (countryCode) => fetchTerritories({ countryCode, includeCountryFallbacks: true }),
  (countryCode) => countryCode,
  (territory) => territory.key,
);
